import React, {FC, memo} from "react";
import momentTz from "moment-timezone";
import {Space, Spin} from "antd";
import {
    ArrayDataOptions,
    Currency,
    Maybe,
    ScheduledPaymentSummary,
    useGetScheduledPaymentsSummaryQuery,
} from "../../generated/graphql";
import {useCurrency} from "../../helpers/currencyHelper";
import {renderAmount} from "../../helpers/renderAmount";

type PaymentsFooterProps = {
    contentType: "openPayment" | "donePayment";
    options: Maybe<ArrayDataOptions> | undefined;
};

const PaymentsFooter: FC<PaymentsFooterProps> = ({options, contentType}) => {
    const currency = useCurrency();
    const filterIsSet = options?.filter && options?.filter?.length > 0;

    const {
        data: summaryData,
        loading: loadingSummaryData,
        error: errorSummaryData,
    } = useGetScheduledPaymentsSummaryQuery({
        variables: {
            paymentDone: contentType === "donePayment",
            options,
            // gefilterte Summe passt zur Liste; die Jahressumme bleibt serverseitig vollständig
            respectArchiveSetting: true,
        },
        // fetchPolicy: "network-only",
        pollInterval: 1000 * 60 * 10,
        // pollInterval: 1000 * 10,
    });

    if (errorSummaryData) {
        console.log("errorSummaryData:::", errorSummaryData);
    }

    const summary: ScheduledPaymentSummary | undefined = summaryData?.scheduledPaymentSummary;

    const valueStyle: React.CSSProperties = {
        fontWeight: "bold",
    };

    const itemType = contentType === "donePayment" ? "Umsätze" : "Posten";

    const FilteredSummary = () => {
        return (
            <Space size={3}>
                {`Gefilterte ${itemType}:`}
                <div style={valueStyle}>
                    {renderAmount({
                        amount: summary?.filtered.sum ?? (0 as number),
                        currency: currency.short as Currency,
                    })}
                </div>
            </Space>
        );
    };

    // Jahr in der Org-Zeitzone (moment-Default aus TimezoneBootstrap), passend zur
    // Server-Jahresklammer in getScheduledPaymentSummaryByPaymentStatus (#1019).
    const thisYear = momentTz().year();

    const TotalSummary = () => {
        return (
            <Space size={4}>
                {`Alle ${itemType} ${thisYear}:`}
                <div style={valueStyle}>
                    {renderAmount({
                        amount: summary?.total.sum ?? (0 as number),
                        currency: currency.short as Currency,
                    })}
                </div>
            </Space>
        );
    };

    if (loadingSummaryData) {
        return (
            <div>
                <Spin />
            </div>
        );
    }

    return (
        <Space>
            {filterIsSet && (
                <>
                    <FilteredSummary />
                    <div>{"|"}</div>
                </>
            )}

            <TotalSummary />
        </Space>
    );
};

export default memo(PaymentsFooter);
